import { render, staticRenderFns } from "./LoginSimple.vue?vue&type=template&id=4c6ff62a&scoped=true"
import script from "./LoginSimple.vue?vue&type=script&lang=js"
export * from "./LoginSimple.vue?vue&type=script&lang=js"
import style0 from "./LoginSimple.vue?vue&type=style&index=0&id=4c6ff62a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ff62a",
  null
  
)

export default component.exports